import { compose } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { withNamespaces } from '@edulastic/localization'
import { TabFilterButtons } from '@edulastic/common'

// actions
import { setFilterAction } from '../../sharedDucks/AssignmentModule/ducks'
import {
  filterSelector,
  FILTERS,
  assignmentsCountByFilerNameSelector,
} from '../ducks'

// styled components
import { BreadcrumbWrapper } from '../../styled'
import { setStatusBgColor } from '../../utils'

const AssignmentSubHeader = ({
  t,
  setFilter,
  filter,
  assignmentsCountByFilerName,
}) => {
  const filterItems = Object.keys(FILTERS)

  // Convert filter items to tabs format
  const tabs = useMemo(
    () =>
      filterItems.map((value) => ({
        value,
        label: FILTERS[value],
        content: null, // No content needed for filter tabs
      })),
    [filterItems]
  )

  // Find active tab index
  const activeTabIndex = useMemo(
    () => filterItems.findIndex((value) => FILTERS[value] === filter),
    [filterItems, filter]
  )

  const handleTabChange = (tabIndex) => {
    const selectedValue = filterItems[tabIndex]
    setFilter(FILTERS[selectedValue])
  }

  return (
    <BreadcrumbWrapper>
      <TabFilterButtons
        tabs={tabs}
        activeTab={activeTabIndex}
        onTabChange={handleTabChange}
        selectedTheme="default"
        filter={filter}
        setStatusBgColor={setStatusBgColor}
        t={t}
        assignmentsCountByFilerName={assignmentsCountByFilerName}
      />
    </BreadcrumbWrapper>
  )
}

const enhance = compose(
  withNamespaces('default'),
  connect(
    (state) => ({
      filter: filterSelector(state),
      assignmentsCountByFilerName: assignmentsCountByFilerNameSelector(state),
    }),
    {
      setFilter: setFilterAction,
    }
  )
)

export default enhance(AssignmentSubHeader)

AssignmentSubHeader.propTypes = {
  t: PropTypes.func.isRequired,
  filter: PropTypes.string.isRequired,
  setFilter: PropTypes.func.isRequired,
  assignmentsCountByFilerName: PropTypes.object.isRequired,
}
